// =========================
// Sidebar & Layout Styles
// =========================



// =========================
// Sidebar Styles
// =========================

export const sidebarListItemIconSx = {
  filter: "contrast(0.01) brightness(1.5) saturate(0.15)",
  minWidth: 30,
};

export const sidebarGetListItemButtonSx = (selected: boolean) => ({
  bgcolor: selected ? "primary.main" : "transparent",
  color: selected ? "white" : "inherit",
  width: "100%",
  boxSizing: "border-box",
  transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
  "&.Mui-selected": {
    bgcolor: "primary.main",
    color: "white",
    "&:hover": { bgcolor: "primary.dark" },
  },
  "&:hover": {
    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
  },
});

export const sidebarGetChildrenListItemButtonSx = (selected: boolean) => ({
  pl: 6,
  width: "100%",
  boxSizing: "border-box",
  bgcolor: selected ? "primary.light" : "transparent",
  transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
  "&.Mui-selected": {
    bgcolor: "primary.main",
    color: "white",
    "&:hover": { bgcolor: "primary.dark" },
  },
  "&:hover": {
    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
  },
});

export const sidebarDrawerSx = (isCollapsed: boolean) => {
  const DRAWER_WIDTH = 240;
  const DRAWER_COLLAPSED_WIDTH = 80;
  return {
    width: isCollapsed ? DRAWER_COLLAPSED_WIDTH : DRAWER_WIDTH,
    transition: "width 0.45s cubic-bezier(0.4, 0, 0.2, 1)",
    "& .MuiDrawer-paper": {
      width: isCollapsed ? DRAWER_COLLAPSED_WIDTH : DRAWER_WIDTH,
      height: "100dvh",
      minHeight: "100vh",
      boxSizing: "border-box",
      transition: "width 0.45s cubic-bezier(0.4, 0, 0.2, 1)",
      overflowX: "hidden",
      overflowY: "hidden",
      position: "fixed",
      top: 0,
      left: 0,
      display: "flex",
      flexDirection: "column",
      fontFamily: "'montserrat', sans-serif",
      fontSize: "0.875rem",
      padding: 0,
      margin: 0,
      "& .MuiList-root": {
        width: "100%",
      },
      "& .MuiListItemText-primary": {
        fontFamily: "'montserrat', sans-serif",
        fontSize: "0.9rem",
        fontWeight: 500,
      },
      "& .MuiListItemText-secondary": {
        fontFamily: "'montserrat', sans-serif",
        fontSize: "0.75rem",
      },
      "& .MuiListItem-root": {
        fontFamily: "'montserrat', sans-serif",
      },
    },
  };
};

export const sidebarToggleButtonContainerSx = {
  position: "fixed" as const,
  bottom: "24px",
  left: "216px",
  zIndex: 1201,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  transition: "left 0.45s cubic-bezier(0.4, 0, 0.2, 1)",
};

export const sidebarToggleButtonContainerCollapsedSx = {
  position: "fixed" as const,
  bottom: "24px",
  left: "56px",
  zIndex: 1201,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  transition: "left 0.45s cubic-bezier(0.4, 0, 0.2, 1)",
};

export const sidebarToggleButtonSx = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "6px",
  cursor: "pointer",
  borderRadius: "50%",
  background: "primary.main",
  color: "white",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  fontSize: "20px",
  fontWeight: "bold",
  lineHeight: 1,
  "&:hover": {
    transform: "scale(1.05)",
  },
  "& svg": {
    transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  },
};

export const sidebarListItemWithTransitionSx = {
  "& .MuiCollapse-root": {
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important",
  },
};

export const sidebarCollapsedListItemSx = (isCollapsed: boolean) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column" as const,
  padding: isCollapsed ? "8px" : "16px",
  transition: "padding 0.3s ease-in-out",
});

// =========================
// Sidebar Collapsed Menu Styles
// =========================

export const sidebarCollapsedMenuPaperSx = (mode: "light" | "dark") => ({
  pointerEvents: "auto" as const,
  backgroundColor: mode === "dark" ? "#1a1a1a" : "#ffffff",
  minWidth: 160,
  borderRadius: "8px",
  border: `1px solid ${mode === "dark" ? "rgba(0, 170, 255, 0.2)" : "rgba(0, 0, 0, 0.12)"}`,
  boxShadow: "auto",
  padding: 0,
  overflow: "hidden",
  fontFamily: "'montserrat', sans-serif",
});

export const sidebarCollapsedMenuItemPrimarySx = {
  px: 2,
  py: 1.2,
  backgroundColor: "transparent",
  transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
  "&:hover": {
    backgroundColor: "primary.main",
    "& .MuiSvgIcon-root, & svg": {
      color: "white !important",
    },
    "& .MuiTypography-root": {
      color: "white !important",
    },
  },
  display: "flex",
  alignItems: "center",
  gap: 1.5,
  minHeight: 48,
};

export const sidebarCollapsedMenuItemPrimaryIconBoxSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: 28,
  minHeight: 28,
  "& svg": {
    fontSize: "1.3rem !important",
    color: "#00aaff !important",
    filter: "contrast(0.01) brightness(1.5) saturate(0.15)",
    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
  },
};

export const sidebarCollapsedMenuItemPrimaryTextSx = (mode: "light" | "dark") => ({
  fontWeight: 600,
  fontSize: "0.9rem",
  color: mode === "dark" ? "rgba(200, 200, 200, 0.8)" : "primary.main",
  textTransform: "none !important" as const,
});

export const sidebarCollapsedMenuItemChildSx = (
  isChildActive: boolean,
  mode: "light" | "dark",
) => ({
  px: 2,
  py: 0.9,
  backgroundColor: isChildActive
    ? mode === "dark"
      ? "rgba(0, 170, 255, 0.1)"
      : "rgba(0, 170, 255, 0.05)"
    : "transparent",
  transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
  "&:hover": {
    backgroundColor: "primary.main",
    "& .MuiSvgIcon-root, & svg": {
      color: "white !important",
    },
  },
  display: "flex",
  alignItems: "center",
  gap: 1.5,
  minHeight: 40,
  marginLeft: 0.5,
  marginRight: 0.5,
  borderRadius: "4px",
});

export const sidebarCollapsedMenuItemChildIconBoxSx = (
  isChildActive: boolean,
  mode: "light" | "dark",
) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: 24,
  minHeight: 24,
  "& svg": {
    fontSize: "1.1rem !important",
    color: isChildActive
      ? "#00aaff !important"
      : mode === "dark"
        ? "rgba(255, 255, 255, 0.7) !important"
        : "rgba(0, 0, 0, 0.4) !important",
    filter: "contrast(0.01) brightness(1.5) saturate(0.15)",
    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
  },
});

export const sidebarCollapsedMenuItemChildTextSx = (
  isChildActive: boolean,
  mode: "light" | "dark",
) => ({
  fontSize: "0.9rem",
  fontWeight: isChildActive ? 500 : 400,
  textTransform: "none !important" as const,
  color: isChildActive
    ? mode === "dark"
      ? "#00aaff"
      : "primary.main"
    : mode === "dark"
      ? "#ffffff"
      : "#666666",
});

// =========================
// Sidebar Mega Menu (Flyout) Styles
// =========================

export const sidebarMegaMenuPaperSx = (mode: "light" | "dark") => ({
  pointerEvents: "auto" as const,
  backgroundColor: mode === "dark" ? "#1a1a1a" : "#ffffff",
  minWidth: 260,
  maxWidth: 320,
  maxHeight: "min(70vh, 560px)",
  overflowY: "auto" as const,
  borderRadius: 0,
  boxShadow: "auto",
  padding: 0,
  fontFamily: "'montserrat', sans-serif",
});

export const sidebarMegaMenuSectionHeaderSx = (
  selected: boolean,
  mode: "light" | "dark",
) => ({
  px: 1.5,
  py: 0.3,
  minHeight: 30,
  borderRadius: "4px",
  marginLeft: 0.5,
  marginRight: 0.5,
  backgroundColor: selected
    ? mode === "dark"
      ? "rgba(0, 170, 255, 0.15)"
      : "rgba(0, 170, 255, 0.08)"
    : "transparent",
  transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
  "&:hover": {
    backgroundColor: "primary.main",
    "& .MuiSvgIcon-root, & svg": {
      color: "white !important",
    },
    "& .MuiTypography-root": {
      color: "white !important",
    },
  },
});

export const sidebarMegaMenuSectionHeaderTextSx = (
  selected: boolean,
  mode: "light" | "dark",
) => ({
  fontWeight: 600,
  fontSize: "0.9rem",
  textTransform: "capitalize" as const,
  letterSpacing: "0.3px",
  color: selected
    ? mode === "dark"
      ? "#00aaff"
      : "primary.main"
    : mode === "dark"
      ? "rgba(255, 255, 255, 0.85)"
      : "#333333",
});

export const sidebarMegaMenuGrandchildrenGroupSx = (mode: "light" | "dark") => ({
  display: "flex",
  flexDirection: "column" as const,
  marginLeft: 2,
  paddingLeft: 1.5,
  borderLeft: `1px solid ${
    mode === "dark" ? "rgba(255, 255, 255, 0.2)" : "rgba(0, 0, 0, 0.18)"
  }`,
});

export const sidebarMegaMenuGrandchildSx = (
  isActive: boolean,
  mode: "light" | "dark",
) => ({
  px: 1.5,
  py: 0.4,
  minHeight: 36,
  borderRadius: "4px",
  marginLeft: 0.5,
  marginRight: 0.5,
  backgroundColor: isActive
    ? mode === "dark"
      ? "rgba(0, 170, 255, 0.1)"
      : "rgba(0, 170, 255, 0.05)"
    : "transparent",
  transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
  "&:hover": {
    backgroundColor: "primary.main",
    "& .MuiTypography-root": {
      color: "white !important",
    },
  },
});

export const sidebarMegaMenuGrandchildTextSx = (
  isActive: boolean,
  mode: "light" | "dark",
) => ({
  fontSize: "0.8rem",
  fontWeight: isActive ? 500 : 400,
  textTransform: "none !important" as const,
  color: isActive
    ? mode === "dark"
      ? "#00aaff"
      : "primary.main"
    : mode === "dark"
      ? "rgba(255, 255, 255, 0.7)"
      : "#666666",
});

export const breadcrumbsSx = (mode: "light" | "dark") => ({
  backgroundColor: "transparent",

  color: "#8a8a8a",

  "& .MuiBreadcrumbs-ol": {
    backgroundColor: mode === "dark" ? "#0a0a0a" : "#f5f5f5",
    margin: 0,
    padding: 0,
  },

  "& .MuiBreadcrumbs-li": {
     backgroundColor: mode === "dark" ? "#0a0a0a" : "#f5f5f5",
  },

  "& .MuiBreadcrumbs-separator": {
    mx: 0.75,
  },
});

export const breadcrumbsContainerSx = () => ({
  px: 3,
  pt: 2,
  pb: 0,
  backgroundColor: "transparent",
});

export const breadcrumbLinkSx = (mode: "light" | "dark") => ({
  color: mode === "dark" ? "#0a0a0a" : "#8a8a8a",
  backgroundColor: "transparent",
  textDecoration: "none",
  fontSize: "0.75rem",
  fontWeight: 600,
  fontFamily: "montserrat",
  transition: "color 0.2s ease",
  "&:hover": {
    color: "primary.main",
  },
});

export const breadcrumbCurrentSx = (mode: "light" | "dark") => ({
  color: mode === "dark" ? "#00aaff" : "primary.main",
  backgroundColor: "transparent",
  fontWeight: 600,
  fontSize: "0.75rem",
  fontFamily: "montserrat",
});

// =========================
// Forgot Password & Reset Modal Styles
// =========================

// Back button container
export const forgotPasswordBackButtonContainer = {
  display: "flex",
  justifyContent: "flex-start",
  marginBottom: "12px",
};

// Back button icon style
export const forgotPasswordBackButton = {
  color: "#7a7a7a",
  "&:hover": {
    backgroundColor: "rgba(122, 122, 122, 0.1)",
  },
};

// Info text
export const forgotPasswordInfoText = {
  textAlign: "center" as const,
  fontSize: "13px",
  fontFamily: "montserrat",
  color: "#666",
  marginBottom: "20px",
  maxWidth: "260px",
  marginLeft: "auto",
  marginRight: "auto",
};

// Error message box
export const forgotPasswordErrorBox = {
  position: "relative",
  color: "#db2424",
  fontSize: "13px",
  fontFamily: "montserrat",
  marginBottom: "16px",
  textAlign: "center" as const,
  display: "block",
  wordBreak: "break-word" as const,
  maxWidth: "260px",
  marginLeft: "auto",
  marginRight: "auto",
  padding: "10px",
  backgroundColor: "rgba(219, 36, 36, 0.15)",
  borderRadius: "8px",
  border: "1px solid rgba(219, 36, 36, 0.4)",
};

// Username input field
export const forgotPasswordInputField = {
  maxWidth: "260px",
  marginLeft: "auto",
  marginRight: "auto",
  display: "block",
  marginTop: "12px",
  marginBottom: "20px",
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#f5f5f5",
    borderRadius: "12px",
    "& fieldset": {
      borderColor: "#ddd",
    },
    "&:hover fieldset": {
      borderColor: "#bbb",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#999",
    },
  },
  "& .MuiOutlinedInput-input": {
    fontSize: "14px",
    fontFamily: "montserrat",
    padding: "12px 14px",
  },
};

// Send code button
export const forgotPasswordSendCodeButton = (isValid: boolean) => ({
  marginTop: "8px",
  marginBottom: "24px",
  width: "100%" as const,
  maxWidth: "260px",
  marginLeft: "auto",
  marginRight: "auto",
  display: "block" as const,
  backgroundColor: isValid ? "#0A7BC2" : "#c0c0c0",
  color: "white",
  fontSize: "13px",
  fontFamily: "montserrat",
  padding: "12px 20px",
  textTransform: "uppercase" as const,
  fontWeight: 600,
  letterSpacing: "0.5px",
  borderRadius: "10px",
  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.15)",
  "&:hover": {
    backgroundColor: isValid ? "#085A8F" : "#c0c0c0",
  },
  "&:disabled": {
    backgroundColor: "#b0b0b0",
    color: "#ffffff",
  },
  transition: "all 0.3s ease",
});

// Modal container
export const resetModalContainer = {
  backgroundColor: "white",
  borderRadius: "16px",
  padding: "40px 36px",
  maxWidth: "420px",
  width: "85%",
  margin: "0 auto",
  boxShadow: "0 8px 32px rgba(0, 0, 0, 0.15)",
};

// Modal title
export const resetModalTitle = {
  marginBottom: "8px",
  fontWeight: 600,
  fontSize: "18px",
  fontFamily: "montserrat",
  color: "#333",
  textAlign: "center" as const,
};

// Modal description
export const resetModalDescription = {
  fontSize: "13px",
  fontFamily: "montserrat",
  color: "#666",
  textAlign: "center" as const,
  marginBottom: "20px",
  lineHeight: "1.5",
};

// Modal error box
export const resetModalErrorBox = {
  color: "#db2424",
  fontSize: "12px",
  fontFamily: "montserrat",
  marginBottom: "16px",
  textAlign: "center" as const,
  padding: "8px 12px",
  backgroundColor: "rgba(219, 36, 36, 0.1)",
  borderRadius: "6px",
  border: "1px solid rgba(219, 36, 36, 0.3)",
};

// Code input field
export const resetModalCodeInput = {
  marginBottom: "20px",
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#f5f5f5",
    borderRadius: "12px",
    "& fieldset": {
      borderColor: "#ddd",
    },
    "&:hover fieldset": {
      borderColor: "#bbb",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#7a7a7a",
    },
  },
};

// Code input input props
export const resetModalCodeInputProps = {
  maxLength: 6,
  style: {
    textAlign: "center" as const,
    fontSize: "24px",
    letterSpacing: "8px",
    fontWeight: 600,
    fontFamily: "monospace",
  },
};

// Password input field
export const resetModalPasswordInput = {
  marginBottom: "16px",
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#f5f5f5",
    borderRadius: "10px",
    "& fieldset": {
      borderColor: "#ddd",
    },
    "&:hover fieldset": {
      borderColor: "#bbb",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#7a7a7a",
    },
  },
  "& .MuiOutlinedInput-input": {
    fontSize: "14px",
    fontFamily: "montserrat",
    padding: "12px 14px",
  },
  "& .MuiInputBase-input::placeholder": {
    opacity: 0.7,
  },
};

// Confirm password input with conditional border
export const resetModalConfirmPasswordInput = (isMatch: boolean) => ({
  marginBottom: "20px",
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#f5f5f5",
    borderRadius: "10px",
    "& fieldset": {
      borderColor: isMatch && isMatch ? "#4caf50" : "#ddd",
    },
    "&:hover fieldset": {
      borderColor: isMatch && isMatch ? "#4caf50" : "#bbb",
    },
    "&.Mui-focused fieldset": {
      borderColor: isMatch && isMatch ? "#4caf50" : "#7a7a7a",
    },
  },
  "& .MuiOutlinedInput-input": {
    fontSize: "14px",
    fontFamily: "montserrat",
    padding: "12px 14px",
  },
  "& .MuiInputBase-input::placeholder": {
    opacity: 0.7,
  },
});

// Password match indicator
export const resetModalPasswordMatchIndicator = (isMatch: boolean) => ({
  fontSize: "12px",
  fontFamily: "montserrat",
  marginBottom: "16px",
  color: isMatch ? "#4caf50" : "#db2424",
  textAlign: "center" as const,
  fontWeight: 500,
});

// Modal button styles
export const resetModalButton = (isEnabled: boolean) => ({
  backgroundColor: isEnabled ? "#0A7BC2" : "#c0c0c0",
  color: "white",
  fontSize: "13px",
  fontFamily: "montserrat",
  padding: "12px 20px",
  textTransform: "uppercase" as const,
  fontWeight: 600,
  letterSpacing: "0.5px",
  borderRadius: "10px",
  marginBottom: "12px",
  "&:hover": {
    backgroundColor: isEnabled ? "#085A8F" : "#c0c0c0",
  },
  "&:disabled": {
    backgroundColor: "#b0b0b0",
    color: "#ffffff",
  },
  transition: "all 0.3s ease",
});

// Modal outlined button
export const resetModalOutlinedButton = {
  color: "#7a7a7a",
  borderColor: "#ddd",
  fontSize: "13px",
  fontFamily: "montserrat",
  padding: "12px 20px",
  textTransform: "uppercase" as const,
  fontWeight: 600,
  letterSpacing: "0.5px",
  borderRadius: "10px",
  "&:hover": {
    borderColor: "#7a7a7a",
    backgroundColor: "rgba(122, 122, 122, 0.05)",
  },
  "&:disabled": {
    color: "#b0b0b0",
    borderColor: "#ddd",
  },
};

// =========================
// SaaS Footer Styles
// =========================

export const saasFooterRootSx = (mode: "light" | "dark") => ({
  position: "fixed" as const,
  bottom: 0,
  left: 0,
  right: 0,
  width: "100%",
  py: 0.1,
  px: 2,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 2,
  background: mode === "dark" ? "#1a1a1a" : "#f5f5f5",
  borderTop: `1px solid ${mode === "dark" ? "rgba(255,255,255,0.1)" : "#ddd"}`,
  color: "text.secondary",
  fontSize: "0.8rem",
  fontFamily: "'montserrat', sans-serif",
  flexShrink: 0,
  zIndex: 1300,
});

export const saasFooterLinksBox = {
  display: "flex",
  gap: 2,
  alignItems: "center",
};

export const saasFooterSupportLink = {
  fontSize: "0.8rem",
  fontFamily: "'montserrat', sans-serif",
  cursor: "pointer",
  border: "none",
  background: "none",
  padding: 0,
  display: "flex",
  alignItems: "center",
  gap: 0.5,
};

export const saasFooterActionLink = {
  fontSize: "0.8rem",
  fontFamily: "'montserrat', sans-serif",
  cursor: "pointer",
  border: "none",
  background: "none",
  padding: 0,
};

export const saasFooterWhatsAppIcon = {
  fontSize: "0.9rem",
};

export const saasFooterMetaBox = {
  display: "flex",
  gap: 3,
  alignItems: "center",
};

export const saasFooterMetaText = {
  color: "inherit",
  fontSize: "0.8rem",
  fontFamily: "'montserrat', sans-serif",
};
